import { useQuery } from 'react-query';

import { getAuxValues } from 'RestAPIs/AuxiliaryValues';

const useGetAuxiliaryValues = () => {
  const { data, isFetching, isError, refetch } = useQuery(
    ['Auxiliary', 'list'],
    async () => {
      const { data } = await getAuxValues();
      return data;
    }
  );

  return { data, isFetching, isError, refetch };
};

export default useGetAuxiliaryValues;
